import {
  Box,
  List,
  ListItemButton,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material"

import footerWallet from "../../images/home/footerWallet.svg"
import logoDark from "../../images/general/logoDark.svg"
import { Link } from "react-router-dom"

export default function AppFooter() {
  const pageLinks = [
    { title: "Documentation", to: "/" },
    { title: "Pricing", to: "/pricing" },
    { title: "Customers", to: {
      pathname:"/",hash:"customer"
    } },
    { title: "Features", to: "/" },
  ]

  const customerLinks = [
    { title: "Team", to: "/" },
    { title: "About", to: "/about" },
    { title: "Careers ", to: "/" }, 
    { title: "FAQ ", to: "/" }, 
    
  ]

  return (
    <Box boxSizing={"border-box"} p={"35px"} color="white" bgcolor="#111111">
      <Box p={"35px"}>
        <Typography textAlign={"center"} fontWeight="600" fontSize={"2em"}>
          Share, Spend With Ease{" "}
        </Typography>
      </Box>
      <Box
        justifyContent={"space-between"}
        sx={{display: {xs: "block", sm: "flex", md: "flex"}, flexWrap: "wrap"}}
        // alignItems={"center"}
        
      >
        <Box sx={{width: {xs: "100%", sm:"100%", md: "15%"}}} >
          <img src={logoDark} alt="" height={40} />
          <Typography> All right reserved &copy; 2022 </Typography>
        </Box>
        <Box sx={{width: {xs: "100%", sm:"50%", md: "15%"}}}>
          <Typography fontWeight={"600"} fontSize="1.3em" my={"6px"}>
            {" "}
            Pages
          </Typography>
          <List disablePadding dense>
            {pageLinks.map((item) => (
              <Link to={item.to} style={{color:"inherit",textDecoration:"none"}}>
              <ListItemButton disableGutters>
                <ListItemText> {item.title} </ListItemText>
              </ListItemButton>
              </Link>
            ))}
          </List>
        </Box>
        <Box sx={{width: {xs: "100%", sm:"50%", md: "15%"}}}>
          <Typography fontWeight={"600"} fontSize="1.3em" my={"6px"}>
            {" "}
            Company
          </Typography>
          <List disablePadding dense>
            {customerLinks.map((item) => (
              <ListItemButton disableGutters href={item.to}>
                <ListItemText> {item.title} </ListItemText>
              </ListItemButton>
            ))}
          </List>
        </Box>
        <Box sx={{width: {xs: "100%", sm:"40%", md: "15%"}}}>
          <Typography fontWeight={"600"} fontSize="1.3em" my={"6px"}>
            {" "}
            Contact
          </Typography>
          <Stack spacing={"12px"}>
            <Typography>
              21 Nyese Ibrahim Tella Street, Oral Estate, Elegnaza Bus-stop,
              Lekki Expressway. Lagos
            </Typography>
            <Typography>hello@wallX.co</Typography>
            <Typography>
              +234(70) 6328-3502 <br /> +234(01) 630-4704
            </Typography>
          </Stack>
        </Box>
        <Box sx={{width: {xs: "100%", sm:"50%", md: "15%"}}}>
          <Box sx={{mt: 2}}>
            <img height={120} style={{marginRight: "50px"}} src={footerWallet} alt="" />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
